import { render, staticRenderFns } from "./PayfastLoader.vue?vue&type=template&id=57e01e1e&scoped=true"
import script from "./PayfastLoader.vue?vue&type=script&lang=js"
export * from "./PayfastLoader.vue?vue&type=script&lang=js"
import style0 from "./PayfastLoader.vue?vue&type=style&index=0&id=57e01e1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e01e1e",
  null
  
)

export default component.exports